import React, { useState } from 'react';
import { VStack, HStack, Pressable } from 'native-base';
import { ActiveCannabinoid } from '@springbig/shared/src/services/dutchie/schema-types';
import Slider from '~/shared/RangeBar';
import { SpIcon } from '~/shared/Icon';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { Caption } from '~/shared/Typography';

export const Cannabinoid = ({
    type,
}: { type: ActiveCannabinoid }) => {

    const [isDescriptionOpen, setIsDescriptionOpen] =
        useState<boolean>(false);

    return (
        <VStack>
            <HStack space={2}>
                <Caption fontSize={12}>{ type.cannabinoid.name }</Caption>
                <Pressable
                    borderWidth={1}
                    rounded={'3xl'}
                    h={3}
                    w={3}
                    justifyContent={'center'}
                    alignItems={'center'}
                    onPress={() => setIsDescriptionOpen(!isDescriptionOpen)}
                >
                    <SpIcon size={6} icon={faInfo} />
                </Pressable>
            </HStack>
            <HStack alignItems={'center'} justifyContent={'space-evenly'}>
                <Slider defaultValue={type.value} maxValue={100} />
                <Caption w={'20%'} textAlign={'center'} fontSize={12}>
                    { type.value }%
                </Caption>
            </HStack>
            { isDescriptionOpen &&
                <Caption
                    borderBottomWidth={1}
                    pb={2}
                    fontSize={12}
                >
                    { type.cannabinoid.description }
                </Caption>
            }
        </VStack>
    );
};
